// extracted by mini-css-extract-plugin
module.exports = {"couponBadge":"styles_couponBadge__Wovc8","couponText":"styles_couponText__57T14"};